export default __webpack_public_path__ + "static/media/Pc.f59bd036.jpg";